import React from "react";
import logo from "../../assets/images/chart-menu-icon.svg";

const chartMenuLogo = props => <img src={logo} alt="chart" />;

export default chartMenuLogo;
